import { useEffect, useState, useCallback } from "react";

// Floating touch-to-pop particle layer. Give it a theme (see lib/themes.js emojis).
export function ParticleLayer({ emojis = ["🫧"], active = true, count = 18 }) {
  const [particles, setParticles] = useState([]);
  const [bursts, setBursts] = useState([]);

  useEffect(() => {
    if (!active) {
      setParticles([]);
      return;
    }
    const items = Array.from({ length: count }).map((_, i) => ({
      id: `${Date.now()}-${i}`,
      emoji: emojis[Math.floor(Math.random() * emojis.length)],
      left: Math.random() * 92 + 2,
      size: Math.random() * 26 + 26,
      duration: Math.random() * 5 + 6,
      delay: Math.random() * 5,
    }));
    setParticles(items);
  }, [active, count, emojis]);

  const pop = useCallback((e, id) => {
    const x = e.clientX;
    const y = e.clientY;
    setParticles((p) => p.filter((it) => it.id !== id));
    const burstId = `${id}-b`;
    setBursts((b) => [...b, { id: burstId, x, y }]);
    setTimeout(() => setBursts((b) => b.filter((it) => it.id !== burstId)), 400);
    try {
      if (navigator.vibrate) navigator.vibrate(25);
    } catch {}
  }, []);

  if (!active) return null;

  return (
    <div className="pointer-events-none">
      {particles.map((p) => (
        <span
          key={p.id}
          data-testid="floating-particle"
          onClick={(e) => pop(e, p.id)}
          className="particle pointer-events-auto"
          style={{
            left: `${p.left}%`,
            fontSize: `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        >
          {p.emoji}
        </span>
      ))}
      {bursts.map((b) => (
        <span
          key={b.id}
          className="pop-burst"
          style={{
            position: "fixed",
            left: b.x - 14,
            top: b.y - 14,
            fontSize: 30,
            zIndex: 70,
            pointerEvents: "none",
          }}
        >
          💥
        </span>
      ))}
    </div>
  );
}
